import React, {useContext, useReducer, useRef, useState} from "react";
import {createPortal} from "react-dom";


const canUseDOM = !!(
    typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement
);

type ContextProps = {
    show:(rest:ModalHandleProps) => void,
    hide:() => void
}

const ModalContext = React.createContext<ContextProps>({
    show(...rest){},
    hide(){}
});
const { Provider } = ModalContext;

type ModalSuccessProps = {
    confirm:boolean
}

interface ModalHandleProps {
    title?:string
    content: string,
    showCancel?:boolean,
    cancelText?:string,
    confirmText?:string,
    success:(res:ModalSuccessProps) => void
}

export interface ModalProps {
    options?:ModalHandleProps
    status: boolean,
    onClose:() => void
}



const ModalContainer: React.FC<ModalProps> = ({options,status,onClose}) => {



    const cancelHandle = () => {
        onClose()
        if(options){
            options.success({confirm:false})
        }
    }

    const confirmHandle = () => {
        onClose()
        if(options){
            options.success({confirm:true})
        }
    }

    if (status && options) {
        // console.log(options.showCancel)
        return <div className='modal-mask'>
            <div className="modal-box">
                <h3>{ options.title || '提示' }</h3>
                <div className="line"/>
                <div className="content">
                    <p>{ options.content }</p>
                </div>
                <div className="line"/>
                <div className="bns">
                    {
                        options.showCancel !== false && <div className="bn" onClick={cancelHandle}>{ options.cancelText || '取消' }</div>
                    }
                    <div className="bn confirm" onClick={ confirmHandle }>{ options.confirmText || '确定' }</div>
                </div>
            </div>
        </div>
    }
    return null
}



export const ModalProvider: React.FC = (props) => {

    const [status, setShow] = useState<boolean>(false)
    const [options,setOptions] = useState<ModalHandleProps>()
    const show = (arg:ModalHandleProps) => {
        setShow(true)
        setOptions(arg)
    }

    const hide = () => {
        setShow(false)
    }


    const portalTarget = canUseDOM ? document.body : null;

    return <Provider value={{ show,hide }}>
        {props.children}
        {
            portalTarget && createPortal(
                <ModalContainer status={ status } onClose={() => setShow(false)} options={options}/>,
                portalTarget
            )
        }
    </Provider>

}

export const useModal = () => {
    const ctx = useContext(ModalContext)

    if(!ctx){
        throw Error('The `useModal` hook must be called from a descendent of the `ModalProvider`.');
    }

    return {
        show:ctx.show,
        hide:ctx.hide
    }

}
